import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Change,
  Reset,
} from "../../../store/async-actions/digitalmarketing/header";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import DashTable from "./DashTable";
import { Button } from "@mui/material";
import { Col, Row } from "react-bootstrap";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import { useNavigate } from "react-router-dom";
import {
  useGetAppoinmentListQuery,
  useGetAppoinmentbyIdQuery,
} from "../../../Service/appoinment";
import { useGetDashboardStatusesQuery } from "../../../Service/dashboard";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import PermissionCheck from "../../../Component/PermissionCheck";
import moment from "moment";
import DateRangePicker from "../../../Component/DigitalMarketing/Forms/DateRangePicker";
import { FiFilter } from "react-icons/fi";

function Appoinment() {
  const Customer = useSelector((state: any) => state.dashboard);
  const initialstate = {
    startDate: null,
    endDate: null,
  };
  const [pagination, setpagination] = useState(1);
  const [filter, setFilter] = useState("");
  const [active, setActive] = useState(1);
  const dispatch = useDispatch<any>();
  const getStatus = useGetDashboardStatusesQuery();
  const [date, setDate] = useState(initialstate);
  const [dateRange, setDateRange] = useState(initialstate);
  const [paramsValue, setParamsValue] = useState({
    date: initialstate,
  });
  const [show1, setShow1] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const { open, message, openSnackBar, type } = useSnackbar();

  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };
  const pagi = {
    pageNo: pagination,
    date: paramsValue?.date,
    // filter: filter,
    name: searchValue,
  };
  const {
    data: appoinment,
    refetch,
    isLoading,
  } = useGetAppoinmentListQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });
// console.log(appoinment);

  useEffect(() => {
    setpagination(1);
  }, [filter, searchValue]);
  useEffect(() => {
    dispatch(Reset());
  }, [dispatch]);

  const onFilter = (value) => {
    if (value === "All") {
      setFilter("");
    } else {
      setFilter(value);
    }
  };
  useEffect(() => {
    const data: any = {
      first: "Appointments",
    };
    dispatch(Change(data));
  }, [dispatch]);
  const values = [
    { id: 7, name: "All" },
    { id: 1, name: "Needs action" },
    { id: 2, name: "Converted" },
  ];
  const onHandleChange = (event) => {
    const { name, value } = event.target;
    if (name === "date") {
      setDate({
        startDate: moment(value[0]).format("YYYY-MM-DD"),
        endDate: moment(value[1]).format("YYYY-MM-DD"),
      });
      setDateRange(value);
    } else {
      setSearchValue(event.target.value);
    }
  };
  const ListFilter = () => {
    if (
      !date?.startDate ||
      date?.startDate === "Invalid date" ||
      date?.endDate !== "Invalid date"
    ) {
      setParamsValue({
        date,
      });
      setShow1(true);
      setpagination(1);
    } else {
      openSnackBar("Please select end date!", "error");
    }
  };
  const ClearFilter = () => {
    setShow1(false);
    setDate(initialstate);
    setDateRange(initialstate);
    setParamsValue({ date: initialstate });
    setSearchValue("");
  };
  return (
    <React.Fragment>
      <div>
        <Toast open={open} type={type} message={message} />
        <Row className="mb-3">
          <Col md={5} className="mb-3">
            <SearchBox
              value={searchValue}
              onChange={(event) => onHandleChange(event)}
            />
          </Col>
          <Col md={7} className="d-flex mb-3 justify-content-between">
            <DateRangePicker
              DisableFutureDate={true}
              date={dateRange}
              key_name="date"
              handleChange={onHandleChange}
            />{" "}
            <div className="filter f-14 mx-2 cursor">
              <Button variant="contained" onClick={ListFilter} id="btn-add">
                {" "}
                <FiFilter />
                &nbsp; Filter
              </Button>
            </div>
            {show1 && (
              <p
                className="clear-filter f-14 mb-0 mt-1 mx-2 cursor"
                onClick={ClearFilter}
              >
                X Clear filters
              </p>
            )}
          </Col>
        </Row>
        {PermissionCheck("appointments", "add") && (
          <Row className="mb-3">
            <Col>
              <Button
                className="right mb-2"
                variant="contained"
                style={{width:"160px"}}
                id="btn"
                onClick={() => navigate("add")}
              >
                + New Appointment
              </Button>
            </Col>
          </Row>
        )}

        <DashTable
          customer={appoinment}
          isLoading={isLoading}
          refetch={refetch}
        />
     {!isLoading && <Pagination
          setpagination={setpagination}
          pagination={pagination}
          data={appoinment}
        />}
      </div>
    </React.Fragment>
  );
}

export default React.memo(Appoinment);
